"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizableContainer = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var Tooltip_1 = require("../Tooltip");
var Icon_1 = require("../Icon");
var translation_1 = require("../../utils/translation");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ResizableContainer'), (0, recompose_1.withState)('_ref', 'setRef', React.createRef()), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.initialWidth !== nextProps.initialWidth) {
            nextProps._ref.current.style.width = "".concat(nextProps.initialWidth, "px");
        }
    }
}), recompose_1.pure);
exports.ResizableContainer = enhance(function (props) {
    var _a = React.useState(false), resizing = _a[0], setResize = _a[1];
    var _b = React.useState(false), initialized = _b[0], setInitialized = _b[1];
    var _c = React.useState(0), start = _c[0], setStart = _c[1];
    var _d = React.useState(props.isOpen), isOpen = _d[0], setIsOpen = _d[1];
    var resize = function () {
        React.useEffect(function () {
            if (!props._ref)
                return;
            var x = props.offsetLeft;
            var width = 0;
            var element = props._ref.current;
            if (!initialized) {
                element.style.width = "".concat(props.initialWidth, "px");
                setInitialized(true);
            }
            if (props.isOpen) {
                setIsOpen(props.isOpen);
            }
            if (!resizing)
                return;
            var handleMouseMove = function (e) {
                var current = e.clientX - x;
                if (resizing) {
                    x = e.clientX;
                    width += current;
                    element.style.width = "".concat(width, "px");
                }
            };
            var handleMouseUp = function (e) {
                e.stopPropagation();
                e.preventDefault();
                setResize(false);
                if (Math.abs(start - e.clientX) === 0) {
                    if (isOpen) {
                        width = 0;
                        setIsOpen(false);
                        props.onClick(width);
                        element.style.width = "".concat(width, "px");
                    }
                    else {
                        width = props.defaultOpenWidth || 200;
                        setIsOpen(true);
                        props.onClick(width);
                        element.style.width = "".concat(width, "px");
                    }
                }
                // close if near by left
                if (width <= 5) {
                    width = 0;
                    setIsOpen(false);
                    props.onClick(width);
                }
                else {
                    setIsOpen(true);
                    props.onDragEnd(width);
                }
            };
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
            return function () {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
            };
        }, [resizing]);
        var handleMouseDown = function (e) {
            e.stopPropagation();
            e.preventDefault();
            setResize(true);
            setStart(e.clientX);
        };
        return {
            onMouseDown: handleMouseDown
        };
    };
    var drag = resize();
    return (React.createElement("div", { className: "resizable-container" },
        React.createElement("div", { className: "list", ref: props._ref }, props.children),
        React.createElement("div", { id: "resize-list", className: "divider" },
            React.createElement("div", __assign({ className: "resizer" }, drag),
                React.createElement("div", __assign({ className: "button" }, props.onClick, { draggable: true }),
                    React.createElement(Tooltip_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("userfront/resibleContainer/".concat(isOpen ? 'open' : 'close'))) },
                        React.createElement(Icon_1.Icon, { className: "fa fa-sharp fa-solid ".concat(isOpen ? 'fa-angle-right' : 'fa-angle-left') })))))));
});
//# sourceMappingURL=index.js.map